import { AppBar, CssBaseline, Toolbar, Typography } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import { TabMobileDashboard, DrawerItems } from './components';
import {
  DashboardLandingPage,
  DoodleArea,
  LeftMenuArea,
  ToolArea,
  TreedomArea,
} from './pages/index';
import { AccountMenu } from '../../components/Navbar/components';
import { useStyles } from './style';

function DashboardHomeClann({ keycloak, savatarURL }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap className={classes.appBarTypography}>
            Dashboard
          </Typography>
          <AccountMenu
            edge="end"
            fullKeycloak={keycloak}
            savatarURL={savatarURL}
            isDashboard={true}
          />
        </Toolbar>
      </AppBar>

      <DrawerItems />
      <main className={classes.content}>
        <div className={classes.toolbar} />

        <Routes>
          <Route index element={<DashboardLandingPage />} />
          <Route path="doodle" element={<DoodleArea />} />
          <Route path="left-menu" element={<LeftMenuArea />} />
          <Route path="tools" element={<ToolArea />} />
          <Route path="treedom" element={<TreedomArea />} />
        </Routes>
      </main>
      <TabMobileDashboard />
    </div>
  );
}

export default DashboardHomeClann;
